export default __webpack_public_path__ + "static/media/feedback.1f772dab.svg";